var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"menu-icon",attrs:{"to":"/signout","title":"Se déconnecter","tag":"div"}},[_c('div',[_c('img',{attrs:{"src":"/static/images/icons/Logout.svg"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }